import React from 'react';
interface SectionHeadingProps {
  kicker?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  tone?: 'dark' | 'light';
}
export function SectionHeading({
  kicker,
  title,
  subtitle,
  align = 'center',
  tone = 'dark'
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return <div className={isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-296" data-mp="3k0yg66klmz86">
      {kicker ? <p className={`font-display text-sm font-bold ${tone === 'light' ? 'text-aqua' : 'text-bright'}`} data-id="element-297" data-mp="blohz9jtye5o">
          {kicker}
        </p> : null}
      <h2 className={`mt-2 font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl ${tone === 'light' ? 'text-white' : 'text-navy'}`} data-id="element-298" data-mp="1tiuod4iwkwt">
        {title}
      </h2>
      {subtitle ? <p className={`mt-4 text-base leading-relaxed ${tone === 'light' ? 'text-white/80' : 'text-charcoal/70'}`} data-id="element-299" data-mp="uh4xvk9u9nj5">
          {subtitle}
        </p> : null}
    </div>;
}